/* eslint-disable @typescript-eslint/no-explicit-any */
import { useDispatch } from "react-redux";
import { setAccountingAccountFilter } from "../index";

export const useAccountingAccountFilterActions = () => {
  const dispatch = useDispatch();
  const updateFilter: any = ({ key, value }: { key: string; value: any }) =>
    dispatch(setAccountingAccountFilter({ key, value }));

  return { updateFilter };
};
